import { Heading, Paragraph } from "@/components/ui/Typography";
import type { MicroSite } from "@/lib/api";
import { sanitizeHtml } from "@/utils/helpers/html";

const Overview = ({data}:{data:MicroSite}) => {

 if(!data){
    return null;
  };

  const PreviewComponent = () => {
    return (
      <div className="flex relative flex-col w-full items-center text-center p-4 lg:p-20 gap-4 lg:gap-8 justify-center" style={{backgroundColor: data?.branding?.websiteColorCode}} >   
          <div className="flex items-center gap-3">
          <Heading level={1} style={{color: data?.branding?.textColorCode}}>{data?.headerSectionTwo?.headerSectionTwoTitle}</Heading>
          </div>
          <Paragraph dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.headerSectionTwo?.headerSectionTwoDescription ?? "") }} style={{color: data?.branding?.textColorCode}}></Paragraph>
      </div>
    )
  };

  return (
    <div>
      <PreviewComponent />
    </div>
  )
}

export default Overview